import { useMemo, useState } from "react";

import { compareNormalizedStrings } from "@/react/utils/stringComparison";

import { toCompassVariant } from "./modalHelpers";

interface UseSecureConfirmationModalParams {
  confirmUserPrompt: string;
  confirmVariant?: "primary" | "danger";
  isDisabled?: boolean;
  onCancel?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
}

export const useSecureConfirmationModal = ({
  confirmUserPrompt,
  confirmVariant,
  isDisabled,
  onCancel,
  onClose,
  onConfirm,
}: UseSecureConfirmationModalParams) => {
  const [userInput, setUserInput] = useState("");

  const shouldDisableButton = useMemo(
    () =>
      !compareNormalizedStrings(userInput, confirmUserPrompt) ||
      Boolean(isDisabled),
    [userInput, confirmUserPrompt, isDisabled],
  );

  const resetInput = () => {
    setUserInput("");
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      resetInput();
      onClose?.();
    }
  };

  const handleCancel = () => {
    resetInput();
    onCancel?.();
  };

  const handleConfirm = () => {
    resetInput();
    onConfirm?.();
  };

  return {
    userInput,
    setUserInput,
    shouldDisableButton,
    compassVariant: toCompassVariant(confirmVariant),
    handleOpenChange,
    handleCancel,
    handleConfirm,
  };
};
